import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=ac30f028&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=ac30f028&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myProject\\cbi-site-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ac30f028')) {
      api.createRecord('ac30f028', component.options)
    } else {
      api.reload('ac30f028', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=ac30f028&", function () {
      api.rerender('ac30f028', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/qualityControl/components/detail.vue"
export default component.exports